import EnergyChart from '../nutrition/charts/EnergyChart';
import ChartPlaceholder from '../nutrition/charts/placeholders/ChartPlaceholder';
import ErrorMessage from '../ui/ErrorMessage';
import LoadingSpinner from '../ui/LoadingSpinner';

const DiaryEnergyChart = ({ title, data, isLoading, isError, error, placeholderText }) => (
    <div className="energy">
        <p className="energy-chart-description">{title}</p>

        {isError && <ErrorMessage message={error?.message} />}
        {isLoading && <LoadingSpinner />}

        {!isLoading &&
            !isError &&
            (data?.values?.some((v) => v > 0) ? (
                <EnergyChart {...data} singleChart />
            ) : (
                <ChartPlaceholder text={placeholderText} />
            ))}
    </div>
);

export default DiaryEnergyChart;
